// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import * as bootstrap from "bootstrap";
import "./channels";
import "./controllers";

// Attach Bootstrap to global scope for debugging and compatibility
window.bootstrap = bootstrap;

// ActiveStorage.start(); // Disabled to avoid direct upload compatibility issues

function initTooltips() {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(el => {
    // clean up tooltip
    const tt = bootstrap.Tooltip.getInstance(el)
    if (tt) {
      tt.hide()
      tt.dispose()
    }
    // create new instance
    new bootstrap.Tooltip(el)
  })
  // remove any orphan poppers
  document.querySelectorAll(".tooltip").forEach(node => node.remove())
}

document.addEventListener("turbo:load", initTooltips)
document.addEventListener("turbo:frame-load", initTooltips)
